import { motion } from "framer-motion";
import React from "react";
import CourseProfile from "./layout/CourseProfile";
import "./MyProfile.css";

const containerProfile={
  hidden:{
    opacity:0,
    x:"100vh"
  },
  visible:{
    opacity:1,
    x:"0",
    transition:{
      type:"spring",
      stiffness:120
    }
  }
}

const MyProfile = () => {
  return (
    <div className="myprofile">
      <div className="container container-custom-profile">
        <div className="profile-title-container">
          <div className="container-again">
            <h1 className="profile-title">My Courses</h1>
          </div>
        </div>

        <div className="in-progress rounded">
          <motion.div className="container-again" variants={containerProfile} initial="hidden" animate="visible" >
            <h2 className="progress-title">Inprogress</h2>
            <div className="profile-course">
              <CourseProfile />
              <CourseProfile />
            </div>
          </motion.div>
        </div>

        <div className="in-progress rounded">
          <div className="container-again">
            <h2 className="progress-title">completed</h2>
            <div className="profile-course">
              <CourseProfile />
              <CourseProfile />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
